export default function SVGRefrigerator(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g clipPath="url(#clip0_1216_19260)">
                <path d="M23.1152 8.88867V17.7759" stroke="#757575" strokeWidth="1.77778" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M23.1152 35.5557V47.4056" stroke="#757575" strokeWidth="1.77778" strokeLinecap="round" strokeLinejoin="round" />
                <rect x="15.3945" y="3" width="33" height="20" rx="2" stroke="#757575" strokeWidth="2" />
                <rect x="15.3945" y="27" width="33" height="34" rx="2" stroke="#757575" strokeWidth="2" />
            </g>
            <defs>
                <clipPath id="clip0_1216_19260">
                    <rect width="64" height="64" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
